import { Controller, useFormContext } from 'react-hook-form';
import { TagPicker } from '../components/TagPicker';
import type { SignupFormValues } from '../schema';

export const Step13TagsOferta = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<SignupFormValues>();

  return (
    <Controller
      control={control}
      name="tagsOfertaIds"
      render={({ field }) => (
        <TagPicker
          category="OFERTA"
          selectedIds={field.value ?? []}
          onChange={field.onChange}
          maxSelections={3}
          errorMessage={errors.tagsOfertaIds?.message}
        />
      )}
    />
  );
};
